module.exports = __webpack_public_path__ + "static/media/stromtech.93552ea0.jpg";